import React from 'react';

export default function Footer() {
  const style = {
    marginTop: '10px',
    padding: '10px',
    fontSize: '12px',
    minHeight: '60px',
    lineHeight: '16px',
  };
  return (
    <footer style={style}>
      <div>
        SA2s are small statistical areas used by the ABS to show local-level
        data, usually covering suburbs or clusters of suburbs.
        <br />
        Source: ABS Personal Income in Australia
      </div>
    </footer>
  );
}
